import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes, FaCog, FaCheck } from 'react-icons/fa';
import './Cookies.css';

const Cookies = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always true, cannot be disabled
    analytics: false,
    marketing: false,
    functional: false
  });

  useEffect(() => {
    // TESTING MODE - Always show banner for development
    //setIsVisible(true);
    
    //Check if user has already made a choice
    const cookiesAccepted = localStorage.getItem('cookies-accepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    } else {
      // Load saved preferences
      const savedPreferences = localStorage.getItem('cookie-preferences');
      if (savedPreferences) {
        setPreferences(JSON.parse(savedPreferences));
      }
    }
  }, []);

  const acceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true,
      functional: true
    };
    setPreferences(allAccepted);
    localStorage.setItem('cookies-accepted', 'true');
    localStorage.setItem('cookie-preferences', JSON.stringify(allAccepted));
    setIsVisible(false);
    setShowSettings(false);
  };

  const acceptSelected = () => {
    localStorage.setItem('cookies-accepted', 'true');
    localStorage.setItem('cookie-preferences', JSON.stringify(preferences));
    setIsVisible(false);
    setShowSettings(false);
  };

  const rejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false,
      functional: false
    };
    setPreferences(onlyNecessary);
    localStorage.setItem('cookies-accepted', 'true');
    localStorage.setItem('cookie-preferences', JSON.stringify(onlyNecessary));
    setIsVisible(false);
    setShowSettings(false);
  };

  const togglePreference = (type) => {
    if (type === 'necessary') return; // Cannot disable necessary cookies
    setPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  if (!isVisible) return null;

  return (
    <div className="cookies-overlay">
      <div className="cookies-banner">
        <button 
          className="cookies-close"
          onClick={() => setIsVisible(false)}
          aria-label="Zatvoriť"
        >
          <FaTimes />
        </button>

        {!showSettings ? (
          <div className="cookies-content">
            <div className="cookies-icon">
              <FaCookie />
            </div>
            
            <div className="cookies-text">
              <h3>Používame cookies 🍪</h3>
              <p>
                Naša webová stránka používa cookies na zlepšenie vášho zážitku z prehliadania, 
                analýzu návštevnosti a personalizáciu obsahu. Súhlasom s použitím cookies 
                nám pomáhate poskytovať lepšie služby.
              </p>
            </div>

            <div className="cookies-actions">
              <button className="btn btn-primary" onClick={acceptAll}>
                <FaCheck /> Prijať všetko
              </button>
              <button className="btn btn-secondary" onClick={rejectAll}>
                Iba nevyhnutné
              </button>
              <button 
                className="btn btn-outline" 
                onClick={() => setShowSettings(true)}
              >
                <FaCog /> Nastavenia
              </button>
            </div>
          </div>
        ) : (
          <div className="cookies-settings">
            <div className="cookies-settings-header">
              <h3>Nastavenia cookies</h3>
              <p>Vyberte si, ktoré cookies chcete povoliť:</p>
            </div>

            <div className="cookies-categories">
              <div className="cookie-category">
                <div className="category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={preferences.necessary}
                      disabled
                    />
                    <span className="slider disabled"></span>
                  </label>
                  <div className="category-info">
                    <h4>Nevyhnutné cookies</h4>
                    <p>Tieto cookies sú potrebné pre základné fungovanie stránky a nemožno ich vypnúť.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={preferences.functional}
                      onChange={() => togglePreference('functional')}
                    />
                    <span className="slider"></span>
                  </label>
                  <div className="category-info">
                    <h4>Funkčné cookies</h4>
                    <p>Umožňujú rozšírené funkcie ako zdieľanie obsahu a personalizáciu.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={() => togglePreference('analytics')}
                    />
                    <span className="slider"></span>
                  </label>
                  <div className="category-info">
                    <h4>Analytické cookies</h4>
                    <p>Pomáhajú nám pochopiť, ako návštevníci používajú našu stránku.</p>
                  </div>
                </div>
              </div>

              <div className="cookie-category">
                <div className="category-header">
                  <label className="cookie-switch">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={() => togglePreference('marketing')}
                    />
                    <span className="slider"></span>
                  </label>
                  <div className="category-info">
                    <h4>Marketingové cookies</h4>
                    <p>Používajú sa na zobrazovanie relevantných reklám a ponúk.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="cookies-settings-actions">
              <button className="btn btn-primary" onClick={acceptSelected}>
                <FaCheck /> Uložiť nastavenia
              </button>
              <button className="btn btn-secondary" onClick={acceptAll}>
                Prijať všetko
              </button>
              <button 
                className="btn btn-outline" 
                onClick={() => setShowSettings(false)}
              >
                Späť
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cookies;